import BackIcon from "@/assets/images/icons/left_16.svg?inline";
import PriceIcon from "@/assets/images/icons/report_price.svg?inline";
import SliderField from "@/components/sliderField";
// import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

export default {
  name: "price-range",

  data() {
    return {
      isShowDropDown: false,
      // cacheFilters: [],
      newRange: [],
      sliderOptions: [],
      options: {
        currency: null,
        locale: "en",
        precision: 0,
        'value-range': {
          min: 0,
          max: 999999999
        }
      }
    };
  },

  props: {
    range: {
      type: Object,
      default: {}
    }
  },

  computed: {
    cacheFilters() {
      return JSON.parse(JSON.stringify(this.$store.getters.getFilters));
    },

    originValue() {
      if (this.range && this.range.values) {
        return [+this.range.values[0], +this.range.values[1]];
      }
    },

    inputsRange() {
      if (this.range && this.range.tagId && this.cacheFilters.filters) {
        return this.parseValues();
      } else {
        return [120000, 400000];
      }
    }
  },

  methods: {
    parseValues() {
      let filter = this.cacheFilters.filters.find(
        f => f.tagId == this.range.tagId
      );
      
      let vals = [];

      if (filter) {
        vals = JSON.parse(filter.value);
      } else {
        vals = this.range.values;
      }

      this.setFilterValues(vals);

      return vals;
    },

    setFilterValues(newValue) {
      let filterIndex = this.cacheFilters.filters.findIndex(
        f => f.tagId == this.range.tagId
      );

      let filter = {
        tagId: +this.range.tagId,
        value: JSON.stringify(newValue)
      };

      this.$set(this.cacheFilters.filters, filterIndex, filter);

      this.newRange = newValue;
    },

    updateSliderRange(values) {
      this.inputsRange = values;
    },

    updateSearchResults() {
      this.setFilterValues(this.inputsRange);

      this.$store.commit("setFilters", this.cacheFilters);
      this.isShowDropDown = false;
    }
  },

  components: {
    BackIcon,
    PriceIcon,
    SliderField
    // LoadingIcon
  }
};
